/** biome-ignore-all lint/suspicious/noArrayIndexKey: fine for skeletons */
import { Stack, Typography } from "@mui/material";
import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import { TransactionItemSkeleton } from "Components/Shared/Transactions/TransactionItem/TransactionItemSkeleton";
import { TransactionItems } from "Components/Transactions/TransactionItems";
import type { TransactionItem } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const PageResources = Resources.Components.Transactions;

type Props = {
  isLoadingTransactions: boolean;
  initialLimit: number;
  transactions: Array<TransactionItem>;
  isFetchingNextPage: boolean;
  hasNextPage: boolean;
  fetchNextPage: () => void;
  variant: "merchant" | "customer";
  totalCount?: number;
  skeletonsCount?: number;
};

export const TransactionsList = ({
  isLoadingTransactions,
  initialLimit,
  transactions,
  isFetchingNextPage,
  hasNextPage,
  fetchNextPage,
  variant,
  totalCount,
  skeletonsCount = initialLimit,
}: Props) => {
  const { t } = useResource();

  const isLoading = isLoadingTransactions && transactions.length === 0;
  const isShowMoreVisible = hasNextPage && !isFetchingNextPage;
  const skeletons = Array.from({ length: skeletonsCount }).map((_, index) => (
    <TransactionItemSkeleton key={index} />
  ));

  const title =
    totalCount !== undefined
      ? `${t(PageResources.Title)} (${totalCount})`
      : t(PageResources.Title);

  return (
    <Stack>
      <Typography fontWeight={600}>{title}</Typography>
      {isLoading ? (
        skeletons
      ) : (
        <TransactionItems transactions={transactions} variant={variant} />
      )}
      {isFetchingNextPage && skeletons}
      {isShowMoreVisible && (
        <PrimaryButton
          variant="text"
          color="info"
          onClick={() => fetchNextPage()}
          sx={{ alignSelf: "center", mt: 2 }}
        >
          {t(PageResources.LoadMore)}
        </PrimaryButton>
      )}
    </Stack>
  );
};
